/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".questionnaire-head-photo-layout[_ngcontent-%COMP%]{\n  margin: 0.3rem auto 0;\n  width: 2rem;\n  height: 2rem;\n  background-color: transparent;\n  border-radius: 100%;\n  overflow: hidden;\n}\n\n.questionnaire-head-photo-layout[_ngcontent-%COMP%]    > img[_ngcontent-%COMP%]{\n  width: 100%;\n}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/app-questionnaire/questionnaire-head-photo/questionnaire-head-photo.component.css.shim.ngstyle.js.pre-build-optimizer.js